import React from 'react';
// @ts-expect-error props exist
import type { CarouselProps } from 'react-material-ui-carousel/dist//components/Carousel';
import type { ThemeProps } from '@models/types';
import useTheme from '@mui/material/styles/useTheme';

import { MuiCarouselContainer } from './styles';

export const Carousel: React.FC<CarouselProps> = (props) => {
    const theme = useTheme<ThemeProps>();

    return (
        <MuiCarouselContainer
            indicatorContainerProps={{
                style: {
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'center',
                },
                className: 'indicator-container',
            }}
            indicatorIconProps={{}}
            indicatorIconButtonProps={{
                style: {
                    color: theme.palette.primaryA3,
                },
            }}
            activeIndicatorIconButtonProps={{
                style: {
                    color: theme.palette.primaryA1,
                },
            }}
            {...props}
        />
    );
};
